import * as React from 'react';
import { Helmet } from 'react-helmet';
import { css, StyleSheet } from 'aphrodite/no-important';
import { BaseUnit } from '../../theming/baseUnitDefinition';
import { useTheme } from '../../theming/useTheme';
import { MEDIA_BREAKPOINTS } from '../../mediaQueries.const';

interface DisqusProps {
    property?: string;
    canonical: string;
    experiments?: Array<string>;
}

// PROPERTIES DATA FOR DISQUS TEST
const disqusPropertiesData = [{ propertyId: '398', disqusSource: 'one-chicago-center.disqus.com' },
  { propertyId: '39', disqusSource: 'fsjaysjournal.disqus.com' },
  { propertyId: '100', disqusSource: 'bluelinestation.disqus.com' },
  { propertyId: '67', disqusSource: 'pistonpowered.disqus.com' },
  { propertyId: '213', disqusSource: 'hailforfloridahail.disqus.com' },
  { propertyId: '130', disqusSource: 'fsarrowheadaddict.disqus.com' },
  { propertyId: '385', disqusSource: 'winter-is-coming.disqus.com' }];

export const Disqus: React.FunctionComponent<DisqusProps> = props => {
  const { property, canonical, experiments } = props;

  const createStyle = (baseUnit: BaseUnit) => {
    return StyleSheet.create({
      style: {
        paddingLeft: `${baseUnit}px`,
        paddingRight: `${baseUnit}px`,
        [MEDIA_BREAKPOINTS.large]: {
          paddingLeft: `${baseUnit + 80}px`,
        },
      },
    });
  };

  const currentPropertyDisqusSource = disqusPropertiesData.find(propertyData => propertyData.propertyId === property)?.disqusSource;
  const renderDisqus = !!(experiments?.includes('disqus-test|test')) && currentPropertyDisqusSource;
  const disqusConfig = `
      var disqus_config = function () {
      this.page.url = ${canonical};  
      this.page.identifier = ${property};
      };`;

  React.useEffect(() => {
    const scriptElement = document.createElement('script');
    scriptElement.innerHTML = disqusConfig;
    document.head.appendChild(scriptElement);
  }, [disqusConfig]);

  const { baseUnit } = useTheme();
  const style = createStyle(baseUnit);

  return (
    <>
      {renderDisqus && (
        <>
          <div id="disqus_thread" className={css(style.style)} />
          <Helmet>
            <script src={`https://${currentPropertyDisqusSource}/embed.js`} data-timestamp={+new Date()} />
          </Helmet>
        </>
      )}
    </>
  );
};
